import React, {Fragment, useState} from "react";
import Cookies from "universal-cookie";
import {t} from "i18next";

import {AboutMenu} from "./AboutMenu";
import {Link, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {ChevronDownIcon} from "@heroicons/react/20/solid";
import {Popover, Transition} from "@headlessui/react";

import {OtherMenu} from "./OtherMenu";
import {FlyoutNavigationMenu} from "./FlyoutNavigationMenu";
import {useAxiosPrivate} from "../hooks/useAxiosPrivate";
import {logoutFromAccount} from "../service/accountApi";
import {useAuth} from "../hooks/useAuth";

export const Header = ({showSearchModal, setShowSearchModal}) => {
	const navigate = useNavigate();

	const cookies = new Cookies();
	const locale = cookies.get("locale");

	const axiosPrivate = useAxiosPrivate();

	const {
		account,
		setAccount,
		isAuthenticated,
		setIsAuthenticated,
		setAccessToken,
		isAdmin,
		setIsAdmin
	} = useAuth();

	const [isLanguageChangeDropdownOpen, setIsLanguageChangeDropdownOpen] = useState(false);

	const [selectedLanguage, setSelectedLanguage] = useState(
		locale === "en"
			? "English"
			: "मराठी"
	);

	const handleLanguageDropdown = (language) => {
		console.log("Language Selected: ", language);
		if (language === cookies.get("locale")) {
			setIsLanguageChangeDropdownOpen(false);
			setIsLanguageChangeDropdownOpen(false);
			return;
		}
		cookies.set("locale", language, {path: "/"});
		// setSelectedLanguage(language === "en" ? "English" : "मराठी");
		window.location.reload();
	};

	const handleLogout = async () => {
		try {
			const logoutResponse = await logoutFromAccount(axiosPrivate);
			console.log("Logout Response: ", logoutResponse);

			if (logoutResponse.success) {
				console.log("Logged Out");
				if (account.lastName?.toLowerCase() === "joglekar") {
					toast.success(t("HEADER.LOGOUT_SUCCESS.JOGLEKAR"));
				} else {
					toast.success(t("HEADER.LOGOUT_SUCCESS.NON_JOGLEKAR"));
				}
				setAccount();
				setAccessToken();
				setIsAuthenticated(false);
				setIsAdmin(false);
				navigate('/home', {
					replace: true,
				});
			} else {
				toast.error(logoutResponse.message);
				console.log("Logout Error in Try Block: ", logoutResponse.error);
			}
		} catch (error) {
			console.error("Logout Error in Catch Block: ", error);
		}
	};

	return (
		<header
			className={`fixed flex items-center justify-between 
                bg-white shadow-lg z-[90] rounded-full 
                
                portrait:h-[2.5rem] portrait:p-[0.4rem] portrait:pl-[0.65rem]
                portrait:sm:h-[4rem] portrait:sm:p-[0.65rem] portrait:sm:pl-[1.5rem]
                portrait:jk:h-[3.5rem] portrait:jk:p-[0.5rem]
                
                landscape:h-[2.5rem] landscape:p-[0.4rem]
                landscape:jk:h-[3.5rem] landscape:jk:p-[0.4rem]
                
                portrait:top-[0.75rem] portrait:inset-x-[0.75rem]
                landscape:top-[0.5rem] landscape:inset-x-[0.5rem]`}
			aria-label="Global"
		>
			{/* Menu | Logo */}
			<div
				className="h-full flex items-center
                portrait:gap-x-[0.25rem] portrait:sm:gap-x-[0.75rem]
                landscape:gap-x-[0.5rem]"
			>
				{/* Dropdown Menu for Smaller Screens */}
				<FlyoutNavigationMenu/>

				{/* Logo */}
				<Link
					to="/home"
					key="logo"
					className="h-full flex items-center
                    gap-x-[0.5rem] portrait:sm:gap-x-[0.75rem]"
				>
					<img
						className="h-full aspect-square"
						src="/other_imgs/logo-joglekar kul-72x72.png"
						alt="Joglekarkul Logo"
					/>
					<h1
						key="logo-name"
						className="hidden xs:flex font-custom-bold
                            text-[1rem] portrait:xs:text-[1rem] portrait:sm:text-[1.75rem] portrait:jk:text-[1.5rem]
                            landscape:text-[1.1rem] landscape:jk:text-[1.5rem]"
					>
						{t("HEADER.JOGLEKARKUL")}
					</h1>
				</Link>
			</div>

			{/* Navigation Menu */}
			<div
				className="hidden
                    portrait:jk:max-h-full portrait:jk:flex portrait:jk:flex-1
                    portrait:jk:items-center portrait:jk:justify-center
                    portrait:jk:px-[0.5rem] portrait:jk:gap-x-[1.25rem]
                    landscape:md:max-h-full landscape:md:flex landscape:md:flex-1
                    landscape:md:items-center landscape:md:justify-center
                    landscape:md:px-[0.2rem] landscape:md:gap-x-[1rem]
                    landscape:jk:px-[0.5rem] landscape:jk:gap-x-[1.5rem]"
			>
				<AboutMenu/>

				{/* Kulavruksh */}
				<button
					onClick={() => {
						if (!isAuthenticated) {
							new Cookies().set("authRequired", true, {path: '/'});
							window.open("/login", "_self");
						} else {
							window.open("/kulavruksh", "_self");
						}
					}}
					key="Kulavruksh"
					className="min-w-fit flex items-center gap-2 text-[1rem]
                        portrait:sm:text-[0.6rem] portrait:jk:text-[1.15rem]
                        landscape:sm:text-[0.75rem] landscape:jk:text-[1rem]
                        font-custom-medium leading-6 text-gray-900"
				>
					<p className="line-clamp-1">
						{t("HEADER.KULAVRUKSH")}
					</p>
				</button>

				{/* Yellow Page */}
				<button
					onClick={() => {
						if (!isAuthenticated) {
							new Cookies().set("authRequired", true, {path: '/'});
							window.open('/login', '_self');
						} else {
							window.open("/yellow-page", '_self');
						}
					}}
					key="Yellow Page"
					className="min-w-fit flex items-center gap-2 text-[1rem]
                        portrait:sm:text-[0.6rem] portrait:jk:text-[1.15rem]
                        landscape:sm:text-[0.75rem] landscape:jk:text-[1rem]
                        font-custom-medium leading-6 text-gray-900"
				>
					<p className="line-clamp-1">
						{t("HEADER.YELLOW_PAGE")}
					</p>
				</button>

				{/* News & Events */}
				{/*<button*/}
				{/*    onClick={() => {*/}
				{/*        if (!isAuthenticated) {*/}
				{/*            new Cookies().set("authRequired", true, {path: '/'});*/}
				{/*            window.open('/login', '_self');*/}
				{/*        } else {*/}
				{/*            window.open("/news-and-events", '_self');*/}
				{/*        }*/}
				{/*    }}*/}
				{/*    key="News & Events"*/}
				{/*    className="min-w-fit flex items-center gap-2 text-[1rem]*/}
				{/*        portrait:sm:text-[0.6rem] portrait:jk:text-[1.15rem]*/}
				{/*        landscape:sm:text-[0.75rem] landscape:jk:text-[1rem]*/}
				{/*        font-custom-medium leading-6 text-gray-900"*/}
				{/*>*/}
				{/*    <p className="line-clamp-1">*/}
				{/*        {t("HEADER.OTHER_MENU.NEWS_EVENTS.TITLE")}*/}
				{/*    </p>*/}
				{/*</button>*/}

				{/* Help Each Other */}
				<button
					onClick={() => {
						if (!isAuthenticated) {
							new Cookies().set("authRequired", true, {path: '/'});
							window.open('/login', '_self');
						} else {
							window.open("/help-each-other", '_self');
						}
					}}
					key="Help Each Other"
					className="min-w-fit flex items-center gap-2 text-[1rem]
                        portrait:sm:text-[0.6rem] portrait:jk:text-[1.15rem]
                        landscape:sm:text-[0.75rem] landscape:jk:text-[1rem]
                        font-custom-medium leading-6 text-gray-900"
				>
					<p className="line-clamp-1">
						{t("HEADER.HELP_EACH_OTHER")}
					</p>
				</button>

				<OtherMenu/>
			</div>

			{/* Language Selection | Login / Register Button | Profile Button */}
			<div
				className="max-h-full h-full flex items-center justify-center
                    portrait:gap-x-[0.35rem] portrait:sm:gap-x-[0.5rem] portrait:jk:gap-x-[0.5rem]
                    landscape:gap-x-[0.35rem] landscape:jk:gap-x-[0.5rem]"
			>
				{/* Language Selection */}
				{window.location.pathname.includes("home") && (
					<Popover className="relative flex">
						{({}) => {
							// To prevent the body from scrolling when the popover is isLanguageChangeDropdownOpen
							document.body.classList.toggle("overflow-y-hidden", isLanguageChangeDropdownOpen);

							return (
								<>
									<button
										onMouseEnter={() => {
											console.log("LanguageChange Dropdown MouseEnter");
											setIsLanguageChangeDropdownOpen(true);
										}}
										onMouseLeave={() => {
											console.log("LanguageChange Dropdown MouseLeave");
											setIsLanguageChangeDropdownOpen(false);
										}}
										onClick={() => {
											console.log("LanguageChange Dropdown Clicked!");
											if (isLanguageChangeDropdownOpen) {
												console.log("LanguageChange Dropdown Clicked -- CLOSE!");
												setIsLanguageChangeDropdownOpen(false);
											} else {
												console.log("LanguageChange Dropdown Clicked -- OPEN!");
												setIsLanguageChangeDropdownOpen(true);
											}
										}}
										onBlur={() => {
											console.log("LanguageChange Dropdown OnBlur");
											setIsLanguageChangeDropdownOpen(false);
										}}
										className="h-full inline-flex items-center justify-center gap-x-[0.05rem]
                                        portrait:sm:gap-x-[0.25rem] outline-none"
									>
										<img
											className="h-[2.5vh]
                                                portrait:h-[1rem] portrait:sm:h-[1.75rem] portrait:jk:h-[1.5rem]
                                                landscape:h-[1rem] landscape:sm:h-[1.1rem] landscape:jk:h-[1.25rem]
                                                aspect-square"
											src={locale === "en"
												? "/assets/english-to-marathi-language-icon.svg"
												: "/assets/marathi-to-english-language-icon.svg"}
											alt={selectedLanguage}
										/>

										{/* landscape:sm:text-[2vh] */}
										<p
											className="hidden
                                                font-custom-medium leading-6 text-gray-900"
										>
											{selectedLanguage}
										</p>

										<ChevronDownIcon
											className={`h-[1rem] w-[1rem] 
                                                portrait:h-[0.75rem] portrait:w-[0.75rem]
                                                portrait:sm:h-[1rem] portrait:sm:w-[1rem]
                                                portrait:jk:h-[1.25rem] portrait:jk:w-[1.25rem]
                                                landscape:sm:h-[0.85rem] landscape:sm:w-[0.85rem]
                                                landscape:jk:h-[1rem] landscape:jk:w-[1rem] 
                                                ${isLanguageChangeDropdownOpen ? "rotate-180" : "rotate-0"} 
                                                transition-all duration-150 ease-in-out`}
											aria-hidden="true"
										/>
									</button>

									<Transition
										show={isLanguageChangeDropdownOpen}
										as={Fragment}
										enter="transition ease-out duration-200"
										enterFrom="opacity-0 translate-y-1"
										enterTo="opacity-100 translate-y-0"
										leave="transition ease-in duration-150"
										leaveFrom="opacity-100 translate-y-0"
										leaveTo="opacity-0 translate-y-1"
									>
										<Popover.Panel
											onMouseEnter={() => setIsLanguageChangeDropdownOpen(true)}
											onMouseLeave={() => setIsLanguageChangeDropdownOpen(false)}
											className="absolute left-1/2 z-10 flex w-screen
                                                max-w-max -translate-x-1/2 rounded-3xl
                                                portrait:mt-[1.5rem] portrait:jk:mt-[2rem]
                                                landscape:mt-[1.5rem] landscape:jk:mt-[2rem]"
										>
											<div
												className={`bg-white flex flex-col overflow-hidden gap-y-[0.4rem]
                                                        shadow-lg leading-6 rounded-lg xl:rounded-xl w-fit
                                                        ring-2 ring-orange-300/5`}
											>
												<button
													onClick={() => handleLanguageDropdown("en")}
													className="pt-[0.4rem]
                                                        portrait:px-[1.5rem] portrait:jk:px-[1.5rem]
                                                        portrait:text-[0.75rem] portrait:jk:text-[1rem]
                                                        landscape:px-[1.5rem] landscape:jk:px-[1.5rem]
                                                        landscape:text-[0.75rem] landscape:jk:text-[1rem]
                                                        font-custom-medium leading-normal
                                                        text-gray-600 hover:bg-gray-200"
												>
													English
												</button>
												<button
													onClick={() => handleLanguageDropdown("mr")}
													className="pb-[0.4rem]
                                                        portrait:px-[1.5rem] portrait:jk:px-[1.5rem]
                                                        portrait:text-[0.75rem] portrait:jk:text-[1rem]
                                                        landscape:sm:px-[1.5rem] landscape:jk:px-[1.5rem]
                                                        landscape:text-[0.75rem] landscape:jk:text-[1rem]
                                                        font-custom-medium leading-normal
                                                        text-gray-600 hover:bg-gray-200"
												>
													मराठी
												</button>
											</div>
										</Popover.Panel>
									</Transition>
								</>
							);
						}}
					</Popover>
				)}

				{/* Search Button */}
				<button
					className={`flex items-center justify-center 
                        h-full aspect-square rounded-md bg-white
                        border border-[#D4D4D4] shadow-lg shadow-black/10`}
					onClick={() => navigate('/search')}
				>
					<img
						className="h-[70%] aspect-square"
						src="/assets/advanced-user-search-icon.svg"
						alt="Search"
					/>
				</button>

				{/* Admin Dashboard Button */}
				{
					isAuthenticated && isAdmin && (
						<button
							className={`flex items-center justify-center 
                                h-full aspect-square rounded-md bg-white
                                border border-[#D4D4D4] shadow-lg shadow-black/10`}
							onClick={() => navigate('/super-user/dashboard')}
						>
							<img
								className="h-[70%] aspect-square"
								src="/assets/admin-icon-2.png"
								alt="Search"
							/>
						</button>
					)
				}

				{!isAuthenticated ? (
					<>
						{/* Login / Register Button */}
						<button
							onClick={() => navigate("/login")}
							className="arrow-button inline-flex items-center justify-between rounded-full
                                portrait:gap-x-[0.15rem] portrait:sm:gap-x-[0.4rem] portrait:jk:gap-x-[0.4rem]
                                landscape:gap-x-[0.35rem] landscape:jk:gap-x-[0.5rem]

                                portrait:pl-[0.75rem] portrait:pr-[0.35rem] portrait:py-[0.25rem]
                                portrait:sm:pl-[1.25rem] portrait:sm:pr-[0.5rem] portrait:sm:py-[0.4rem]
                                portrait:jk:pl-[1.15rem] portrait:jk:pr-[0.5rem] portrait:jk:py-[0.45rem]

                                landscape:pl-[0.85rem] landscape:pr-[0.35rem] landscape:py-[0.3rem]
                                landscape:jk:pl-[1.05rem] landscape:jk:pr-[0.4rem] landscape:jk:py-[0.35rem]

                                bg-[#D26A53] hover:bg-[#D26A53] shadow-xl
                                hover:ring-orange-300 hover:ring-offset-1 hover:ring-4
                                transition-all duration-300 ease-in-out"
						>
							<p
								className="font-custom-medium text-white leading-tight
                                    line-clamp-1 overflow-x-scroll no-scrollbar
                                    portrait:text-[0.75rem] portrait:md:text-[1.25rem] portrait:jk:text-[1.15rem]
                                    landscape:text-[0.8rem] landscape:md:text-[0.85rem] landscape:jk:text-[1rem]"
							>
								{t("HEADER.LOGIN")}
							</p>
							<svg
								viewBox="0 0 6 6"
								fill="none"
								id={"arrow-icon"}
								className="portrait:h-[0.65rem] portrait:w-[0.65rem]
                                    portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                    portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                    landscape:h-[0.65rem] landscape:w-[0.65rem]
                                    landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                    landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M3 1L5 3L3 5"
									id={"arrow-icon-tip"}
									stroke="white"
									strokeLinecap="square"
								/>
								<path
									d="M1 3L4 3"
									id={"arrow-icon-line"}
									stroke="white"
									strokeLinecap="square"
								/>
							</svg>
						</button>
					</>
				) : (
					<>
						{/* Outsider's Search Button */}
						{window.location.pathname.toLowerCase().includes("kulavruksh") &&
							account.outsider && (
								<div
									onClick={() => setShowSearchModal(!showSearchModal)}
									className={`flex flex-row items-center justify-between gap-x-2 xl:gap-x-4 cursor-pointer 
                                                bg-white rounded-full p-[1vh] pr-[1vw]
                                                transition-all duration-500 ease
                                                border-2 border-[#EAEAEA] hover:shadow-xl`}
								>
									<div
										className={`h-[1.5vw] w-[1.5vw] p-[0.5vh] rounded-full 
                                                    bg-[#F5F5F5] flex items-center justify-center`}
									>
										<img
											className="h-full w-full"
											src="/assets/search-icon-dark.svg"
											alt="Search Icon"
										/>
									</div>
									<p
										style={{
											userSelect: "none",
										}}
										className={
											"font-custom-medium leading-tight text-[1.75vh] text-[#787878]"
										}
									>
										{t("HEADER.SEARCH")}
									</p>
								</div>
							)
						}

						{/* Logout Button */}
						{(window.location.pathname.includes("personal-profile") || account.outsider) && (
							<button
								onClick={handleLogout}
								className={`arrow-button inline-flex items-center justify-between rounded-full
                                    pl-[0.75rem] pr-[0.35rem] py-[0.2rem]
                                    portrait:gap-x-[0.15rem] portrait:sm:gap-x-[0.4rem] portrait:jk:gap-x-[0.4rem]
                                    landscape:gap-x-[0.35rem] landscape:jk:gap-x-[0.5rem]
                                    portrait:pl-[0.75rem] portrait:pr-[0.35rem] portrait:py-[0.25rem]
                                    portrait:sm:pl-[1.25rem] portrait:sm:pr-[0.5rem] portrait:sm:py-[0.4rem]
                                    portrait:jk:pl-[1.15rem] portrait:jk:pr-[0.5rem] portrait:jk:py-[0.45rem]
                                    landscape:pl-[0.85rem] landscape:pr-[0.35rem] landscape:py-[0.3rem]
                                    landscape:jk:pl-[1.05rem] landscape:jk:pr-[0.4rem] landscape:jk:py-[0.35rem]
                                    bg-[#D26A53] hover:bg-[#D26A53] shadow-xl
                                    hover:ring-orange-300 hover:ring-offset-1 hover:ring-4
                                    transition-all duration-300 ease-in-out`}
							>
								<p
									className="font-custom-medium text-white leading-tight
                                        line-clamp-1 overflow-x-scroll no-scrollbar
                                        portrait:text-[0.75rem] portrait:md:text-[1.25rem] portrait:jk:text-[1.15rem]
                                        landscape:text-[0.8rem] landscape:md:text-[0.85rem] landscape:jk:text-[1rem]"
								>
									{t("HEADER.LOGOUT")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									className="portrait:h-[0.65rem] portrait:w-[0.65rem]
                                        portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                        portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                        landscape:h-[0.65rem] landscape:w-[0.65rem]
                                        landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                        landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="white"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="white"
										strokeLinecap="square"
									/>
								</svg>
							</button>
						)}

						{/* Profile Button (PFP) */}
						{
							<Link
								className={`h-full flex items-center rounded-full`}
								to={account.outsider
									? ""
									: account.nodeId
										? "/personal-profile"
										: "/kulavruksh"}
								onClick={() => {
									if (!account.outsider && !account.nodeId) {
										toast.info(t("HEADER.COMPLETE_PROFILE"));
									}
								}}
							>
								{account.imageUrl ? (
									account.imageUrl.length <= 2 ? (
										<div
											className={`z-10 h-full aspect-square rounded-full overflow-hidden 
                                                flex items-center justify-center ${account.imageUrlBg} 
                                                border border-[#D4D4D4] shadow-lg shadow-black/30`}
										>
											<p
												className="font-custom-mono-bold text-white leading-tight
                                                    line-clamp-1 overflow-x-scroll no-scrollbar
                                                    portrait:text-[0.75rem] portrait:md:text-[1.25rem] portrait:jk:text-[1.15rem]
                                                    landscape:text-[0.8rem] landscape:md:text-[0.85rem] landscape:jk:text-[1rem]"
											>
												{account.imageUrl.toUpperCase()}
											</p>
										</div>
									) : (
										<img
											className="z-10 h-full aspect-square rounded-full"
											src={account.imageUrl}
											alt="User Profile Image"
											referrerPolicy={"no-referrer"}
										/>
									)
								) : (
									<img
										className="h-[5vh] w-auto aspect-square rounded-full bg-[#D26A53]"
										src={"/assets/default-pfp.png"}
										alt="Default PFP"
										referrerPolicy={"no-referrer"}
									/>
								)}
							</Link>
						}
					</>
				)}
			</div>
		</header>
	);
};
